import Repository from './Repository';

const resource = "/placements_groups_data/metrics";
export default {
    page(page=1, limit=10) {
        var offset = (page - 1) * limit
        return Repository.get(`${resource}/?limit=${limit}&offset=${offset}`);
    },
    all() {
        return Repository.get(`${resource}/`);
    },
    get(id) {
        return Repository.get(`${resource}/${id}/`);
    },
    post(data) {
        return Repository.post(`${resource}/`, data);
    },
    update(id, data) {
        return Repository.put(`${resource}/${id}/`, data);
    },
    patch(id, data) {
        return Repository.patch(`${resource}/${id}/`, data);
    },
    serve_metric_types() {
        return Repository.options(`${resource}/`);
    }
}